module.exports = __webpack_public_path__ + "static/media/level-up.825a6d64.svg";